






























































import moment from 'moment';
import store from '@/store';
import {
  LoadingService,
  ExtendMixins,
} from '@/services';
import { dateFormatYYYYMMDD, dateTransactionFormat } from '@/constants';
import { PageBanner } from '@/components/page-components';
import { OpenAttachDocumentsScreen } from '@/mixins/get-content-mixins';
import { UnsubstantiatedClaimResponseModel } from '@/@types/member';

interface Data {
  dateFormatYYYYMMDD: string;
  dateTransactionFormat: string;
  headers: any[];
}

export default ExtendMixins(
  OpenAttachDocumentsScreen,
)
  .extend({
    name: 'SubstantiateClaims',
    beforeRouteEnter(to, from, next) {
      const PROMISES = store.dispatch('getUnsubstantiatedClaims');
      LoadingService.watchPromises(PROMISES)
        .then(next)
        .catch(next);
    },
    data() {
      return {
        dateFormatYYYYMMDD,
        dateTransactionFormat,
        headers: [{}, {}, {}, {}, {}],
      };
    },
    computed: {
      unsubstantiatedClaims(): UnsubstantiatedClaimResponseModel[] {
        return this.$store.getters.unsubstantiatedClaims;
      },
    },
    methods: {
      claimHasDetails(claim): boolean {
        return claim.receivedDate || claim.claimNumber || claim.startDate;
      },
    },
    components: {
      PageBanner,
    },
  });
